var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.3 2.7l-11 11-5-5"}));
}

CheckInline.defaultProps = {"className":"stroke","viewBox":"0 0 16.7 16.7"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
